import { Button } from '@intigral/shared/components/Button';
import LockIcon from '../../../../components/elements/LockIcon';

const LockButton = () => {
    return (
        <Button social secondary>
            <LockIcon relative="true" />
        </Button>
    );
};

export default LockButton;
